import { getField, updateField } from "vuex-map-fields";

export const flightReview = {
  namespaced: true,
  state: {
    booking: {
      reviewerId: "",
      packageId: "",
      reviewStartDate: "",
      reviewEndDate: ""
    },
    packageInfo: {}
  },
  actions: {},
  mutations: {
    updateField,
    updateBooking(state, payload) {
      state.booking = { ...state.booking, ...payload };
    },
    updatePackageInfo(state, payload) {
      state.packageInfo = { ...state.packageInfo, ...payload };
    }
  },
  getters: {
    getField
  }
};
